import { gql } from '@apollo/client';

export const RECUPERAR_SENHA = gql`
  mutation ($email: String!) {
    recuperar(email: $email)
  }
`;
